import React from 'react';
import propTypes from 'prop-types';
import ReactSelect from 'react-select';
import css from 'classnames';

import styles from './select-box.module.css';
import '!style-loader!css-loader!./react-select.css';

const SelectBox = (props) => {
  const {
    name,
    value,
    options,
    handleChange,
    error,
    disabled,
    isLoading,
    selectNameStyle,
  } = props;

  const labelText = error
    ? `Please select a ${name}`
    : name === 'year'
    ? 'Tax year'
    : name;
  const labelTextFormatted =
    labelText.charAt(0).toUpperCase() + labelText.slice(1);
  const errorStyle = error && 'react-select__error';
  const labelErrorStyle = error ? styles.error : '';
  const labelIsDisplayed = value ? styles.labelShow : '';
  return (
    <div className={css([styles.selectContainer, errorStyle, selectNameStyle])}>
      <label
        id={name}
        htmlFor={name}
        className={css([styles.label, labelErrorStyle, labelIsDisplayed])}
      >
        {labelTextFormatted}
      </label>
      <ReactSelect
        name={name}
        inputId={name}
        value={value}
        options={options}
        isDisabled={disabled}
        isLoading={isLoading}
        placeholder={`Select ${name}`}
        onChange={(value, action) => {
          handleChange(value, action);
        }}
        className={'react-select'}
        classNamePrefix={'react-select'}
        aria-labelledby={name}
      />
    </div>
  );
};

SelectBox.propTypes = {
  name: propTypes.string,
  value: propTypes.oneOfType([propTypes.string, propTypes.object]),
  options: propTypes.array,
  handleChange: propTypes.func,
  error: propTypes.oneOfType([propTypes.string, propTypes.bool]),
  disabled: propTypes.bool,
  isLoading: propTypes.bool,
  selectNameStyle: propTypes.oneOfType([propTypes.string, propTypes.bool]),
};

export default SelectBox;
